import { Task } from '@/types';
import { ResponsivePanelWrapper } from '@/components/ui/ResponsivePanelWrapper';
import { TaskPanel } from '@/components/TaskPanel';

interface TaskPanelPanelProps {
  tasks: Task[];
  onTaskClick?: (task: Task) => void;
  onTaskComplete?: (task: Task) => void;
  onTaskDragEnd?: (task: Task) => void;
  onScheduleTask?: (task: Task) => void;
  onSettingsClick?: () => void;
  onAddTask?: () => void;
  onReorder?: (tasks: Task[]) => void;
}

export function TaskPanelPanel({
  tasks,
  onTaskClick,
  onTaskComplete,
  onTaskDragEnd,
  onScheduleTask,
  onSettingsClick,
  onAddTask,
  onReorder,
}: TaskPanelPanelProps) {
  return (
    <ResponsivePanelWrapper panelId="tasks" title="Tasks">
      <TaskPanel
        tasks={tasks}
        onTaskClick={onTaskClick}
        onTaskComplete={onTaskComplete}
        onTaskDragEnd={onTaskDragEnd}
        onScheduleTask={onScheduleTask}
        onSettingsClick={onSettingsClick}
        onAddTask={onAddTask}
        onReorder={onReorder}
        variant="panel"
      />
    </ResponsivePanelWrapper>
  );
}

export default TaskPanelPanel;
